/***
 * @ngdoc service
 * @name BB.Models:BaseModelExtended
 *
 * @description
 * The extension provided for the BaseModel to generalize the usage of the model-specific services
 */

angular.module('BB').factory('BaseModelExtended', (BaseModel, BBWidget) =>
    class BaseModelExtended extends BaseModel {

        constructor(data) {
            super(data);
        }

        /***
         * @ngdoc method
         * @name $query
         * @methodOf BB.Models:Person
         * @description
         * Query the data from company according to the model type
         * Configuration argument can include the following options:
         *   modelName {string}:        The required model-name from the current company
         *   validate {boolean}:        Activation of the model availability validation inside the current company
         *   returnValueOnError {any}:  The default value expected to be returned if the validation results in
         *                              non-availability of the requested model inside the current company
         *   mwValidation {callback}:   A middle-ware which does a pre-processing on the sent parameters, after passing
         *                              the optional validation phase, and before making the $get request
         * For the case of requiring examples, please check the implementations of the child classes.
         *
         * @returns {promise} A returned promise
         */

        static $query(config = {
            validate: false,
            returnValueOnError: null,
            mwValidation: null
        }, params = null) {

            return new Promise((resolve, reject) => {

                // check if the value inside the company should be validated
                if (config.validate && !BBWidget.company.$has(config.modelName)) {

                    // check if the value for the failure needs to be returned
                    if (!config.returnValueOnError)
                        return reject(new BBError('No ${config.modelName} found'));

                    return resolve(config.returnValueOnError);

                } else {

                    // Run the validation middle-ware on the params
                    if (config.mwValidation && typeof config.mwValidation === 'function')
                        config.mwValidation(params);

                    // Run the $get query
                    BBWidget.company.$get(config.modelName, params).then((resource) => {

                            return resource.$get(config.modelName).then((items) => {
                                // Resolve the items
                                return resolve({items, total_entries: resource.total_entries});
                            });

                        }
                        , (err) => {
                            // Reject
                            return reject(err);
                        }
                    );
                }
            });

        }

    }
);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_helpers/BaseModelExtended.js